const apiEndpoints = {
  appControl: {
    versionInfo: "",
  },
  common: {
    uploadMedia: "section/upload-media/",
  },
  auth: {
    login: "user/login/",
    forgotPassaword: "user/forgot-password/",
    resetPassword: "user/reset-password/",
    refresh: "user/token/refresh/",
    updateProfile: "User/UpdateUserProfile/",
    getProfile: "user/profile/",
    changePassword: "user/change-password/",
    magicLinkRequest: "user/login-via-magic-link/",
    magicLinkVerify: "user/verify-magic-link/",
    newMagicLink: "user/new-magic-link/",
  },
  users: {
    getUnreadNotifications: "leaves/notifications/unread/",
    notificationsread: "leaves/make_notifications_read/",
    getStudentsByParent: "user/get-parent-students-list/",
    createLEAAdmin: "admin/create-district-admin/",
    getLEAAdmins: "user/admin/get-district-admin-listing/",
    getLEASubAdmins: "user/get-districtsubadminlist/",
    getLEAAdminDetails: "admin/view-district-admin-detail/",
    getParents: "user/get-parentslist/",
    getTeachers: "user/get-all-teacherslist/",
    getTeachersBygrade: "user/get-grade-teacherslist/",
    getStudents: "user/get-studentslist/",
    getClerks: "user/get-clerklist/",
    getAttendanceCoordinators: "user/get-attendancecoordinatorlist/",
    createParent: "user/create-parents/",
    createStudent: "user/create-students/",
    cleateClerk: "user/create-clerk/",
    createTeacher: "user/create-teachers/",
    createAttendanceCoordinator: "user/create-attandancecoordinator/",
    createLeaSubAdmin: "user/create-district_sub_admin/",
    getProfile: "user/profile/",
    importSisData: "user/import-sis-data/",
    searchUsers: "user/search/",
    //Get full profile details
    getCoordindatorProfile: "user/get-attandancecoordinatorprofile/",
    getStudentProfile: "user/get-studentprofile/",
    getTeacherProfile: "user/get-teacherprofile/",
    getParentProfile: "user/get-parentprofile/",
    getSchoolUserProfile: "user/get-schoolprofile/",
    //Get Individual roaster information
    getRoaster: "user/api/user/get-information/",
  },
  lea: {
    addLEA: "user/admin/create-district-admin/",
    getLEAReport: "leaves/absence-recovered-district-admin/",
    getLEASchool: "leaves/get-schoolreport-district-admin/",
  },
  school: {
    getSchools: "user/admin/view-school-lists/",
    getLeaSchools: "user/get-schoolslist/",
    getStudents: "user/admin/view-students-lists/",
    getLeaStudents: "user/get-districtadminstudents/",
    createSchool: "user/create-schools/",
    getSchoolReports: "leaves/absence-recovered-school-admin/",
    getSubjectByTeacherGrade: "section/subjects/list/?",
  },

  masters: {
    getSchoolGrades: "section/get-grades-listing/",
    assignmentsList: "assignment/get-assignmentslist/",
    exportTopics: "section/export-topic-listing/",
    getAssignment: "assignment/get-assignment/",
    getStudyMaterials: "leaves/get-student-materials/",
    uploadAssignments: "master/create-assignment-master/",
    importAssignments: "section/import-assignment/",
    importGrades: "section/import-grades/",
    importCourse: "section/import-course/",
    importBatches: "section/import-batches/",
    importSubjects: "section/import-subjects/",
    importLeaAdmin: "section/import-lea-admin/",
    importSchool: "section/import-school/",
    importTeacher: "section/import-teacher/",
    importAssign: "section/assign-teacher-grade-subjects/",
  },
  leaves: {
    getStudentLeaves: "leaves/student-list-leave-requests/",
    getLeaveStatus: "leaves/get-statuses/",
    getLeaveRequestDetails: "leaves/leave-request-details/",
    getLeaveRequestsForClerk: "leaves/coordinator-list-leave-requests/",
    getstudentslist: "user/get-studentslist-school/",
    raiseLeaveRequestManual: "leaves/create-leave-requestbycoordinator/",
    getleaverequestfilter: "leaves/get-leaverequestfilter/?student=",
    raiseRequest: "leaves/create-leave-request/",
    parentRequestList: "leaves/parent-list-leave-requests/",
    parentPreviousRequestList: "leaves/parent-leavehistory-requests/",
    teacherRequestList: "leaves/teacher-list-leave-requests/",
    getStatus: "leaves/api/tasks/status/",
    getAdaApprovedLeaves: "leaves/get-leaverequestlist/",
    downlaodADAReport: "leaves/get-leave-recovered-report/",
    getFilteredLeaves: "leaves/get-leaverequestfilter/",
    updateLeaveStatus: "leaves/update-teacherleavestatus/",
    skipLeaveStatus: "leaves/update-leavestatus/",
    principalApproves: "leaves/update-principalsignature/",
    updatePrincipalSuggestion: "leaves/update-suggestions/",
    parentApproves: "leaves/update-parentsignature/",
    leaAdminApproves: "leaves/lea-update-task-status/",
    acApprove: "leaves/coordinator-update-task-status/",
    updateLEASuggestion: "leaves/update-lea-suggestions/",
    notifyLeaveRequest: "leaves/leave_request_email_notify/",
    notifyTeacher: "leaves/teacher_email_notify/",
    notifyAtc: "leaves/atc_leave_notify/",
    notifyLea: "leaves/lea_leave_notify/",
    // School Admin end-to-end flow endpoints
    raiseRequestByPrincipal: "leaves/create-leave-requestbyprincipal/",
    notifyStudent: "leaves/student_email_notify/",
    notifyParent: "leaves/parent_email_notify/",
  },
  recovery: {
    getOverdueTasks: "leaves/get-overdue-tasks-list/",
    getCompletedTasks: "leaves/get-completed-tasks-list/",
    getTasks: "leaves/tasks/",
    getLeaveTasks: "assignment/get-leave-tasks/",
    deleteLeaveTask: "assignment/delete-leave-tasks/",
    assignTaskToRequest: "assignment/assign-task-to-leave-request/",
    updateTask: "assignment/update-tasks/",
    assignTask: "assignment/change-leave-request-status/",
    assignTaskCoordinator: "leaves/create-task-coordinator/",
    getCoordindatorTasks: "leaves/tasks/?status=AttendanceCoordinatorReview",
    getStudentTasks: "leaves/get-student-tasklist/",
    getTaskDetails: "leaves/get-student-task/",
    submitAssignment: "assignment/update-student-submit-task/",
    approveAssignment: "leaves/teacher-update-task-status/",
    approveAssignmentCoordinator: "leaves/coordinator-update-task-status/",
    underReviewTasks: "leaves/get-teacher-undereview-task-list/",
    submitStudentChoice: "leaves/update-student-choice/",
    submitStudentTask: "assignment/update-student-submit-task/",
  },
  dashbaords: {
    superAdmin: "user/admin/dashboard/",
    lea: "user/lea/dashboard/",
    superAdminDashboard: "user/admin/get-reporting/",
    getLeaISComDpletionReport: "leaves/IS-completion-report-district-admin/",
    getLeaISInCompletionReport: "leaves/incomplete-is-by-month-district-admin/",
    getLeaLeaveRecovery: "leaves/leave-recovery-by-month-district-admin/",
    getLeaLeaveStatsDistrict: "leaves/leave-stats-district-admin/up-to-now/",

    getSchoolISCompletionReport: "leaves/IS-completion-report/",
    getSchoolISInCompletionReport: "leaves/incomplete-is-by-month/",
    getSchoolLeaveRecovery: "leaves/leave-recovery-by-month/",
    getSchoolLeaveStatsDistrict: "leaves/leave-stats/up-to-now/",
  },
  reports: {
    allRecovered: "leaves/absence-recovered-leaves-report/",
    coordinator: "leaves/absence-recovered-attendance-coordinator/",
  },
  master: {
    grades: {
      create: "/section/create-grade/",
      list: "/section/get-gradelist/",
      details: "/section/get-gradedetails/",
    },
    courses: {
      create: "/section/create-courses/",
      list: "/section/get-courseslist/",
      details: "/section/get-coursesdetails/",
    },
    batches: {
      create: "/section/create-batches/",
      list: "/section/get-batcheslist/",
      details: "/section/get-batchesdetails/",
    },
    subjects: {
      create: "/section/create-subjects/",
      list: "/section/get-subjectslist/",
      details: "/section/get-subjectdetails/",
    },
    subjectTeachers: {
      create: "/section/create-subjectteachers/",
      list: "/section/get-subjectteacherslist/",
      details: "/section/get-subjectteachersdetails/",
    },
  },
};

export default apiEndpoints;
